import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ae1e716"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "remotesupport" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-sm-9" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "pageheader" }, [
        /*#__PURE__*/_createElementVNode("b", null, "Send commands to remote devices")
      ])
    ])
  ])
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "User id", -1))
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-4 col-form-label" }, "Command", -1))
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "col-sm-8"
}
const _hoisted_13 = { class: "table-responsive table-container" }
const _hoisted_14 = { class: "table table-hover" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "time" }, "Time"),
    /*#__PURE__*/_createElementVNode("th", { class: "user" }, "User"),
    /*#__PURE__*/_createElementVNode("th", { class: "command" }, "Command"),
    /*#__PURE__*/_createElementVNode("th", { class: "status" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "action" }, "Action")
  ])
], -1))
const _hoisted_16 = { class: "table-body-scroll" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border border-secondary border-3" }, null, -1))
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "Time", -1))
const _hoisted_23 = { class: "col-md-10" }
const _hoisted_24 = {
  key: 0,
  class: "row"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "User", -1))
const _hoisted_26 = { class: "col-md-10" }
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "Command", -1))
const _hoisted_29 = { class: "col-md-10" }
const _hoisted_30 = {
  key: 2,
  class: "row"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "Status", -1))
const _hoisted_32 = { class: "col-md-10" }
const _hoisted_33 = {
  key: 3,
  class: "row"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2" }, "Response", -1))
const _hoisted_35 = { class: "col-md-10" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "table-outer-container" }
const _hoisted_38 = { class: "table" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { key: 2 }
const _hoisted_42 = { style: {"font-size":"large"} }

import { ref, computed, onMounted, inject } from 'vue'
import { useStore } from 'vuex'
import { Remotecommand } from '@/models'
import Ably from "ably";

interface State {
  remotesupport: {
    currentcommand: Remotecommand;
    commandlist: Remotecommand[];
  }
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const userid = ref('')
const commandvalue = ref('')

const realtime: Ably.Realtime = inject("realtime");
const channel = realtime.channels.get("act-app");

const currentCommand = computed<Remotecommand>(() => 
  store.getters['remotesupport/currentcommand'] || new Remotecommand()
)
const commandlist = computed<Remotecommand[]>(() => 
  store.getters['remotesupport/commandlist'] || []
)

// Computed properties
const isDatabaseResults = computed(() => 
  currentCommand.value?.command?.toLowerCase().startsWith("select") &&
  !currentCommand.value.response?.toLowerCase().includes("exception")
)

const isExportCommand = computed(() => 
  currentCommand.value?.command?.toLowerCase().startsWith("export")
)

const parsedResponse = computed(() => {
  if (!currentCommand.value?.response) return []
  return currentCommand.value.response.split('\n').map(line => line.split(','))
})

const responseLines = computed(() => 
  currentCommand.value?.response?.split('\n') || []
)

const canSend = computed(() => 
  Boolean(userid.value && commandvalue.value)
)

const setCurrentcommand = (command: Remotecommand) => {
  store.commit('remotesupport/setCurrentcommand', command)
}

const send = async () => {
  if (canSend.value) {
    const newCommand = new Remotecommand({ 
      userid: userid.value, 
      command: commandvalue.value 
    })
    try {
      const commandFromServer = await store.dispatch('remotesupport/addRemotecommand', newCommand)
      store.commit('remotesupport/addRemotecommand', commandFromServer)
      commandvalue.value = ''
      setCurrentcommand(commandFromServer)
    } catch (error) {
      console.error("Error sending command:", error)
      alert("Failed to send command. Please try again.")
    }
  }
}

const deleteCommandItem = async (commandId: string) => {
  if (confirm("Are you sure you want to delete this command?")) {
    try {
      await store.dispatch('remotesupport/deleteCommand', commandId)
      store.commit('remotesupport/removeRemotecommand', commandId)
      if (currentCommand.value.id === commandId) {
        setCurrentcommand(new Remotecommand())
      }
    } catch (error) {
      console.error("Error deleting command:", error)
      alert("Failed to delete command. Please try again.")
    }
  }
}

const isImageUrl = (url: string): boolean => {
  return /\.(jpeg|jpg|gif|png)$/i.test(url)
}

const getFullUrl = (url: string): string => {
  if (url.startsWith('http')) return url
  return `${process.env.VUE_APP_DOWNLOADS_URL || ''}${url}`
}

const downloadImage = (url: string) => {
  const fullUrl = getFullUrl(url)
  const fileName = url.split('/').pop() || 'image.jpg'

  fetch(fullUrl)
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok')
      return response.blob()
    })
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(blobUrl)
    })
    .catch(error => {
      console.error('Error downloading image:', error)
      alert('Failed to download the image. Please try again.')
    })
}

const formatDateTime = (date: string | Date | undefined): string => {
  if (!date) return ''
  const d = new Date(date)
  return d.toLocaleString()
}

const setupRealtimeChannel = () => {
  channel.subscribe("remotecommandresponse", async (message: any) => {
    if (message?.data?.id) {
      try {
        const updatedCommand = await store.dispatch('remotesupport/getRemotecommand', message.data.id)
        const index = commandlist.value.findIndex(c => c.idcopy === updatedCommand.id)
        if (index >= 0) {
          // Create a new array to trigger reactivity
          const newList = [...commandlist.value]
          newList[index] = updatedCommand
          if (currentCommand.value.id === updatedCommand.id) {
            setCurrentcommand(updatedCommand)
          }
        }
      } catch (error) {
        console.error("Error updating command:", error)
      }
    }
  })
}

onMounted(() => {
  setCurrentcommand(new Remotecommand())
  setupRealtimeChannel()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "col-sm-8 form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userid).value = $event))
          }, null, 512), [
            [_vModelText, userid.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "col-sm-8 form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((commandvalue).value = $event))
          }, null, 512), [
            [_vModelText, commandvalue.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary float-end",
              onClick: _withModifiers(send, ["prevent"]),
              disabled: !canSend.value
            }, "Send", 8, _hoisted_11)
          ])
        ])
      ]),
      (commandlist.value?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("tbody", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commandlist.value, (c, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      onClick: ($event: any) => (setCurrentcommand(c)),
                      class: _normalizeClass({ selected: c.id === currentCommand.value?.id })
                    }, [
                      _createElementVNode("td", null, _toDisplayString(formatDateTime(c.createdAt)), 1),
                      _createElementVNode("td", null, _toDisplayString(c.userid), 1),
                      _createElementVNode("td", null, _toDisplayString(c.command), 1),
                      _createElementVNode("td", null, _toDisplayString(c.status), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-danger btn-sm",
                          onClick: _withModifiers(($event: any) => (deleteCommandItem(c.id)), ["stop"])
                        }, "Delete", 8, _hoisted_18)
                      ])
                    ], 10, _hoisted_17))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_19,
    (currentCommand.value?.idcopy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString(formatDateTime(currentCommand.value.createdAt)), 1)
          ]),
          (currentCommand.value.userid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(currentCommand.value.userid), 1)
              ]))
            : _createCommentVNode("", true),
          (currentCommand.value.command)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(currentCommand.value.command), 1)
              ]))
            : _createCommentVNode("", true),
          (currentCommand.value.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, _toDisplayString(currentCommand.value.status), 1)
              ]))
            : _createCommentVNode("", true),
          (currentCommand.value.response)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  (isDatabaseResults.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("table", _hoisted_38, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedResponse.value[0], (header, index) => {
                                  return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(header), 1))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedResponse.value.slice(1), (line, lineIndex) => {
                                return (_openBlock(), _createElementBlock("tr", { key: lineIndex }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line, (item, itemIndex) => {
                                    return (_openBlock(), _createElementBlock("td", { key: itemIndex }, _toDisplayString(item), 1))
                                  }), 128))
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    : (isExportCommand.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(responseLines.value, (line, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "response-line"
                            }, [
                              _createElementVNode("span", null, _toDisplayString(line), 1),
                              (isImageUrl(line))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (downloadImage(line)),
                                    class: "btn btn-primary btn-sm"
                                  }, " Download ", 8, _hoisted_40))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("pre", _hoisted_42, _toDisplayString(currentCommand.value.response), 1)
                        ]))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})